export class Nir {
  private static regex: RegExp = new RegExp("^([1-37-8])([0-9]{2})(0[0-9]|[2-35-9][0-9]|[14][0-2])((0[1-9]|[1-8][0-9]|9[0-69]|2[abAB])(00[1-9]|0[1-9][0-9]|[1-8][0-9]{2}|9[0-8][0-9]|990|999)|(9[78][0-9])(0[1-9]|[1-8][0-9]|90))([0-9]{3})?([0-8][0-9]|9[0-7])$");

  constructor(
    public num: string = "",
    public key: string = ""
  ){

  }

  public isValid(){
    let nir: string = this.num + this.key;
    let patternIsOk = Nir.regex.test(nir);
    nir = nir.replace("2A", "19");
    nir = nir.replace("2B", "18");


    let num: number = parseInt(nir.substr(0, nir.length - 2));
    let key: number = parseInt(nir.substr(-2, 2));


    let computedKey = 97 - num % 97;

    return patternIsOk && computedKey == key;
  }

  public equalsTo(nir: Nir){
    return this.num == nir.num && this.key == nir.key;
  }
}



// WEBPACK FOOTER //
// ./src/app/nir/nir.ts